import * as angular from 'angular';
import * as _ from 'lodash';
import ResourceService from './resource.service';
import UserResource from '../models/user-resource';

export default class UserService extends ResourceService<UserResource> {
  constructor(private BackendService: any) {
    super(BackendService, UserResource);
  }
}

angular.module('ciApp.services').service('UserService', ['BackendService', UserService]);



// WEBPACK FOOTER //
// ./common/services/user.service.ts